import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import PowerSettingsNewRoundedIcon from '@mui/icons-material/PowerSettingsNewRounded';
import { AppBar, Box, Button, Container, IconButton, Toolbar, Tooltip } from '@mui/material';
import { Brand } from './Brand';
import { layoutTokens } from '../theme/archiveTheme';
import { useThemeMode } from '../theme/ThemeModeContext';
import { useAppDispatch } from '../store/hooks';
import { logout } from '../store/authSlice';

export function AppHeader() {
  const dispatch = useAppDispatch();
  const { mode, toggleMode } = useThemeMode();

  const signOut = () => {
    dispatch(logout());
    window.location.assign('/login');
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      color="transparent"
      sx={{
        borderRadius: 0,
        zIndex: 1200,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.42)',
        backdropFilter: mode === 'dark' ? 'blur(12px)' : 'blur(8px)',
        WebkitBackdropFilter: mode === 'dark' ? 'blur(12px)' : 'blur(8px)'
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: layoutTokens.contentWidth }}>
        <Toolbar disableGutters sx={{ minHeight: `${layoutTokens.headerHeight}px !important`, justifyContent: 'space-between' }}>
          <Brand />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Tooltip title={mode === 'light' ? 'Dunkles Design' : 'Helles Design'}>
              <IconButton
                onClick={toggleMode}
                aria-label={mode === 'light' ? 'Dunkles Design aktivieren' : 'Helles Design aktivieren'}
                sx={{ color: 'text.primary' }}
              >
                {mode === 'light' ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
              </IconButton>
            </Tooltip>
            <Button
              color="inherit"
              startIcon={<PowerSettingsNewRoundedIcon />}
              onClick={signOut}
              sx={{ color: 'text.primary', px: { xs: 1.25, sm: 1.75 }, minWidth: 0 }}
            >
              <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Abmelden</Box>
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
